import { useDraggable, useDroppable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'
import React, { createElement, useState } from 'react'

export const Droppable = (props) => {
  const { className, id, type, value, ...restProps } = props

  const { setNodeRef, ...rest } = useDroppable({
    id,
    data: {
      value
    }
  })

  if (type) {
    return createElement(
      type,
      {
        className,
        ref: setNodeRef,
        ...restProps
      },
      props.children(rest)
    )
  }

  return (
    <div ref={setNodeRef} className={className} {...restProps}>
      {props.children(rest)}
    </div>
  )
}

export const Draggable = (props) => {
  const { children, id, value, useDragOverlay = false, style: externalStyle, ...rest } = props

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useDraggable({
    id: 'draggable' + id,
    data: {
      value
    }
  })

  const style = {
    ...externalStyle,
    transition,
    ...(useDragOverlay && isDragging ? {} : { transform: CSS.Translate.toString(transform) }),
    ...(useDragOverlay && isDragging ? { opacity: 0 } : {})
  }

  const propMap = {
    id,
    style,
    ...rest,
    ...attributes
  }

  if (typeof children === 'function') {
    return (
      <div ref={setNodeRef} {...propMap}>
        {children(listeners)}
      </div>
    )
  }

  return (
    <div ref={setNodeRef} {...propMap} {...listeners}>
      {children}
    </div>
  )
}

/**
 * @typedef {Object} ChrofySelectProps
 * @property {string} value
 * @property {string} className
 * @property {function( any ):void} onChange
 * @property {SelectOption[]} options
 * @property {boolean} disabled
 * @property {boolean} hasNoSelect
 * @property {string} selectClassName
 * @property {boolean} lightNoSelect
 */

/**
 * @function ChrofySelect
 * @type {React.FC<ChrofySelectProps>}
 * @component
 */
export const ChrofySelect = (props) => {
  const {
    value,
    onChange,
    className,
    options: _options = [],
    disabled,
    hasNoSelect = true,
    selectClassName = '',
    lightNoSelect = true
  } = props

  const options = hasNoSelect ? [{ label: '未選択', value: '' }, ..._options] : _options

  const [openSelect, setOpenSelect] = useState(false)

  const textLight = lightNoSelect && value === '' ? ' text-gray-700/50 ' : ''
  const selectStyles = selectClassName + ' ' + textLight

  const selectedLabel = options.find((e) => e.value === value)?.label ?? ''

  return (
    <div className={`form-control  ${className}`}>
      <div className="select-control">
        <select
          data-testid={props?.['data-testid']}
          disabled={disabled}
          className={`form-select select-p-large rounded-lg text-h7 pr-10 w-[100%] ${selectStyles} `}
          value={value}
          onClick={() => setOpenSelect((s) => !s)}
          onBlur={() => setOpenSelect(false)}
          onChange={onChange}
          title={selectedLabel || ''}
        >
          {options.map((e, index) => {
            return (
              <option value={e.value} key={index} className="text-gray-900">
                {e.label}
              </option>
            )
          })}
        </select>
        <div className="select-control__icon flex text-base items-center justify-center w-8 absolute pointer-events-none inset-y-0 right-0">
          <span className={`icon-arrow transition ${openSelect ? '-rotate-90' : 'rotate-90'}`}></span>
        </div>
      </div>
    </div>
  )
}
